import { render, staticRenderFns } from "./RelatedOffers.vue?vue&type=template&id=f96a5990&scoped=true&"
import script from "./RelatedOffers.vue?vue&type=script&lang=js&"
export * from "./RelatedOffers.vue?vue&type=script&lang=js&"
import style0 from "./RelatedOffers.vue?vue&type=style&index=0&id=f96a5990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96a5990",
  null
  
)

export default component.exports